import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "../lib/api";

const getVisitorId = () => {
  let id = localStorage.getItem("bpbd_vid");
  if (!id) {
    id = window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Math.random().toString(36).slice(2)}${Date.now()}`;
    localStorage.setItem("bpbd_vid", id);
  }
  return id;
};

export const VisitTracker = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    api.post("/track", { path: pathname, visitor_id: getVisitorId() }).catch(() => {});
  }, [pathname]);
  return null;
};
